<div
    khA11yDialog
    class="news-article-container d-flex flex-column justify-content-start align-items-center"
    data-testid="news-article-modal-container"
>
    <div
        class="bg-blur-layer"
        [ngStyle]="{ 'background-image': 'url(' + data.image + ')' }"
    ></div>

    <div class="bg-blue-overlay"></div>

    <img
        *ngIf="!data.mediaId"
        class="news-article-image"
        [src]="data.image"
        [attr.alt]="data.subject"
    >

    <kh-video
        class="news-article-image"
        *ngIf="data.mediaId"
        [videoId]="data.mediaId"
        [hideRatings]="true"
        [autoplay]="true"
    >
    </kh-video>

    <div khA11yLabelSource class="text-center article-subject kh-heading-lg kh-heading-style kh-text-primary">
        {{ data.subject }}
    </div>

    <div>
        <ng-container *ngIf="data.hyperlink; else staticArticleBody">
            <div
                khA11yClickable
                (click)="goto()"
                class="article-body kh-white kh-body-md cursor-pointer"
                [innerHTML]="transformDescription(data.description)"
            ></div>
        </ng-container>

        <ng-template #staticArticleBody>
            <div
                class="article-body kh-white kh-body-md"
                [innerHTML]="transformDescription(data.description)"
            ></div>
        </ng-template>

        <div
            class="article-button d-flex justify-content-center align-items-center"
            *ngIf="data.linkButtonText && data.hyperlink"
        >
            <button
                class="kh-primary-button kh-medium-title-text spacer-sm"
                (click)="goto()"
                type="button"
            >
                {{ data.linkButtonText }}
            </button>
        </div>
    </div>

    <button
        (click)="closeModal()"
        class="close-button d-flex justify-content-center align-items-center"
        data-testid="close-button"
        [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate"
        type="button"
    >
        <svg
            khA11yHidden
            focusable="false"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.14062 5.99482L13.3866 1.49382C13.8079 1.0473 13.4913 0.313477 12.8774 0.313477H11.0144C10.8337 0.313477 10.66 0.383348 10.5297 0.508475L7.0909 3.80928L3.49731 0.498648C3.36806 0.379577 3.19876 0.313477 3.02302 0.313477H1.15983C0.540526 0.313477 0.226288 1.05855 0.658544 1.50205L4.90119 5.8551L0.58888 10.5113C0.173867 10.9595 0.491671 11.687 1.10244 11.687L3.00681 11.687C3.1922 11.687 3.37002 11.6135 3.50125 11.4826L6.95091 8.04065L10.5294 11.4909C10.6599 11.6167 10.8341 11.687 11.0153 11.687H12.8796C13.4931 11.687 13.8098 10.9538 13.3892 10.5071L9.14062 5.99482Z"
                fill="#000000"
            ></path>
        </svg>
    </button>
</div>
